<!-- If not logged in, then show pre-seen screen -->
<div *ngIf="!isLoggedIn">
    <!-- Navigation Bar -->
    <navbar-cmp></navbar-cmp>
    <div class="guest-image-container">
        <img class="guest-background-img" src="/assets/img/integration-guide-pre-signup-background.png" />
        <div class="guest-background-overlay"></div>
    </div>
    <div class="guest-content">
        <h1 class="guest-title">Start building <span>with Pay10</span></h1>
        <p class="guest-description">
            Get API keys, test in sandbox, and start processing payments in minutes.
        </p>
        <button class="btn-get-started-guest" (click)="navigateToSignup()">Get Started</button>
    </div>
</div>

<!-- If logged in, then show the integration guide -->
<div *ngIf="isLoggedIn" class="main-container" [class.payout-doc]="isPayoutDoc">
    <div *ngIf="docId == ''" class="integration-hero">
        <div class="hero-content">
            <h1 class="hero-title">
                <span class="title-pay10">Pay10</span>
                <span class="title-integration">Integration Guide</span>
            </h1>
            <p class="hero-subtitle">Start integrating Pay10 payments quickly and efficiently.</p>
            <p class="hero-description">
                Follow clear documentation, practical examples, and<br>
                ready-to-use APIs to build reliable and secure payment<br>
                flows.
            </p>
            <button class="btn-get-started" (click)="navigateToFirstMenuItem()">Get Started</button>
        </div>
        <div class="hero-illustration">
            <img src="assets/img/integration-illustration.png" alt="Integration illustration" class="illustration-img">
        </div>
    </div>

    <!-- Document content view -->
    <div *ngIf="docId != ''" class="integration-hero doc-view">
        <div class="doc-layout">
            <div class="doc-left-col">
                <div class="doc-content-area">
                    <ng-container *ngIf="!docNotFound">
                        <!-- <div class="doc-page-header" id="doc-top">
                            <h1 class="doc-page-title">{{ pageTitle }}</h1>
                        </div> -->
                        <ng-container *ngFor="let item of docContent; let i = index">

                            <!-- Header -->
                            <h2 *ngIf="item.type === 'header'" [id]="item.id" class="doc-header">
                                {{ item.content }}
                            </h2>

                            <!-- Sub Header -->
                            <h2 *ngIf="item.type === 'sub-header'" [id]="item.id" class="doc-sub-header">
                                {{ item.content }}
                            </h2>

                            <!-- Icon Header -->
                            <div *ngIf="item.type === 'icon-header'" [id]="item.id" class="doc-icon-header">
                                <span class="doc-icon-header-icon" [innerHTML]="item.icon | safeHtml"></span>
                                <h2 class="doc-icon-header-text" [innerHTML]="item.content | safeHtml"></h2>
                            </div>

                            <!-- Textbox -->
                            <p *ngIf="item.type === 'textbox'" class="doc-textbox"
                                [style.color]="item.color || '#6C7073'"
                                [style]="{'--link-color': item['hyperlink-color'] || '#EA5E22'}"
                                [innerHTML]="item.content | safeHtml">
                            </p>

                            <!-- Note -->
                            <div *ngIf="item.type === 'note'" class="doc-note"
                                [style.background-color]="item['background-color']" [style.color]="item['text-color']"
                                [style.border-left]="'4px solid ' + item['text-color']"
                                [style]="{'--note-link-color': item['hyperlink-color'] || '#EA5E22'}">
                                <div *ngIf="item.header" class="doc-note-header">
                                    <img *ngIf="item.icon" [src]="item.icon" class="doc-note-icon" alt="">
                                    <span class="doc-note-header-text">{{ item.header }}</span>
                                </div>
                                <span class="doc-note-text" [innerHTML]="item.content | safeHtml"></span>
                            </div>

                            <!-- Note (Info) -->
                            <div *ngIf="item.type === 'note-info'" class="doc-note" [id]="item.id"
                                [style.background-color]="item['background-color']" [style.color]="item['text-color']"
                                [style]="{'--note-link-color': item['hyperlink-color'] || '#EA5E22'}">
                                <div *ngIf="item.header" class="doc-note-header">
                                    <img *ngIf="item.icon" [src]="item.icon" class="doc-note-icon" alt="">
                                    <span class="doc-note-header-text">{{ item.header }}</span>
                                </div>
                                <span class="doc-note-text" [innerHTML]="item.content | safeHtml"></span>
                            </div>

                            <!-- Image -->
                            <img *ngIf="item.type === 'img'" [src]="item.content" class="doc-img" [alt]="item.alt">

                            <!-- Enlargeable Image -->
                            <div *ngIf="item.type === 'enlarge-image'" class="doc-img-enlargeable"
                                (click)="openLightbox(item.content, item.alt)">
                                <img [src]="item.content" class="doc-img" [alt]="item.alt">
                                <button type="button" class="doc-img-expand-btn" aria-label="Enlarge image">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <polyline points="15 3 21 3 21 9"></polyline>
                                        <polyline points="9 21 3 21 3 15"></polyline>
                                        <line x1="21" y1="3" x2="14" y2="10"></line>
                                        <line x1="3" y1="21" x2="10" y2="14"></line>
                                    </svg>
                                </button>
                            </div>

                            <!-- Container (accordion) -->
                            <div *ngIf="item.type === 'container'" class="doc-container">
                                <button class="doc-container-header" (click)="toggleContainer(i)">
                                    <span class="doc-container-header-text">{{ item.header }}</span>
                                    <svg *ngIf="item.content && item.content.length > 0" class="doc-container-chevron"
                                        [class.open]="isContainerOpen(i)" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2">
                                        <polyline points="6 9 12 15 18 9"></polyline>
                                    </svg>
                                </button>
                                <div class="doc-container-body" *ngIf="item.content && item.content.length > 0 && isContainerOpen(i)">
                                    <ng-container *ngFor="let subItem of item.content; let j = index">

                                        <!-- Nested Textbox -->
                                        <p *ngIf="subItem.type === 'textbox'" class="doc-textbox"
                                            [style.color]="subItem.color || '#6C7073'"
                                            [style]="{'--link-color': subItem['hyperlink-color'] || '#EA5E22'}"
                                            [innerHTML]="subItem.content | safeHtml">
                                        </p>

                                        <!-- Nested Code -->
                                        <div *ngIf="subItem.type === 'code'" class="doc-code-block">
                                            <div class="doc-code-header">
                                                <span>{{ subItem.header }}</span>
                                            </div>
                                            <div class="doc-code-body">
                                                <button class="doc-copy-btn"
                                                    (click)="copyCode(subItem.content, i * 1000 + j)">
                                                    <span *ngIf="copiedIndex !== i * 1000 + j" class="doc-copy-icon"
                                                        aria-label="Copy"></span>
                                                    <span *ngIf="copiedIndex === i * 1000 + j"
                                                        class="doc-copy-done">✓</span>
                                                </button>
                                                <div class="doc-code-content"
                                                    [innerHTML]="highlightCode(subItem.content, subItem.language) | safeHtml">
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Nested Table -->
                                        <div *ngIf="subItem.type === 'table'" class="doc-table-wrapper">
                                            <table class="doc-table"
                                                [style.table-layout]="subItem.columnWidths ? 'fixed' : null">
                                                <thead>
                                                    <tr>
                                                        <th *ngFor="let col of getTableHeaders(subItem); let i = index"
                                                            [style.width]="columnWidth(subItem, i)">{{ col }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let row of getTableRows(subItem); let rowIdx = index"
                                                        [class.row-odd]="rowIdx % 2 === 0"
                                                        [class.row-even]="rowIdx % 2 === 1">
                                                        <td *ngFor="let cell of row" [innerHTML]="cell | safeHtml"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <!-- Nested Image -->
                                        <img *ngIf="subItem.type === 'img'" [src]="subItem.content" class="doc-img"
                                            [alt]="subItem.alt">

                                        <!-- Nested Enlargeable Image -->
                                        <div *ngIf="subItem.type === 'enlarge-image'" class="doc-img-enlargeable"
                                            (click)="openLightbox(subItem.content, subItem.alt)">
                                            <img [src]="subItem.content" class="doc-img" [alt]="subItem.alt">
                                            <button type="button" class="doc-img-expand-btn" aria-label="Enlarge image">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round">
                                                    <polyline points="15 3 21 3 21 9"></polyline>
                                                    <polyline points="9 21 3 21 3 15"></polyline>
                                                    <line x1="21" y1="3" x2="14" y2="10"></line>
                                                    <line x1="3" y1="21" x2="10" y2="14"></line>
                                                </svg>
                                            </button>
                                        </div>

                                    </ng-container>
                                </div>
                            </div>

                            <!-- Top-level Code -->
                            <div *ngIf="item.type === 'code'" class="doc-code-block">
                                <div class="doc-code-header">
                                    <span>{{ item.header }}</span>
                                </div>
                                <div class="doc-code-body">
                                    <button class="doc-copy-btn" (click)="copyCode(item.content, i)">
                                        <span *ngIf="copiedIndex !== i" class="doc-copy-icon" aria-label="Copy"></span>
                                        <span *ngIf="copiedIndex === i" class="doc-copy-done">✓</span>
                                    </button>
                                    <div class="doc-code-content"
                                        [innerHTML]="highlightCode(item.content, item.language) | safeHtml"></div>
                                </div>
                            </div>

                            <!-- Top-level Table -->
                            <div *ngIf="item.type === 'table'" class="doc-table-wrapper">
                                <table class="doc-table"
                                    [style.table-layout]="item.columnWidths ? 'fixed' : null">
                                    <thead>
                                        <tr>
                                            <th *ngFor="let col of getTableHeaders(item); let i = index"
                                                [style.width]="columnWidth(item, i)">{{ col }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let row of getTableRows(item); let rowIdx = index"
                                            [class.row-odd]="rowIdx % 2 === 0" [class.row-even]="rowIdx % 2 === 1">
                                            <td *ngFor="let cell of row" [innerHTML]="cell | safeHtml"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Enviromment card -->
                            <div *ngIf="item.type === 'enviroment-table'" class="environment-card">
                                <ng-container *ngFor="let _ of item.content; let i = index">
                                    <div *ngIf="i % item.columns === 0" class="environment-row">
                                        <strong [innerHTML]="item.content[i] | safeHtml"></strong>
                                        <code [innerHTML]="item.content[i + 1] | safeHtml"></code>
                                    </div>
                                </ng-container>
                            </div>


                            <!-- List -->
                            <ul *ngIf="item.type === 'list'" class="doc-list" [style.color]="item.color || '#6C7073'"
                                [style]="{'--link-color': item['hyperlink-color'] || '#EA5E22'}">
                                <li *ngFor="let point of item.content" class="doc-list-item"
                                    [innerHTML]="point | safeHtml"></li>
                            </ul>

                            <!-- Copybox (plain text with copy button) -->
                            <div *ngIf="item.type === 'copybox'" class="doc-copybox">
                                <span class="doc-copybox-text">{{ item.content }}</span>
                                <button class="doc-copy-btn doc-copybox-btn" (click)="copyCode(item.content, i)">
                                    <span *ngIf="copiedIndex !== i"><img src="assets/icons/copy-ig.svg"
                                            alt="copy"></span>
                                    <span *ngIf="copiedIndex === i"><img src="assets/icons/tick.svg"
                                            alt="copied"></span>
                                </button>
                            </div>

                        </ng-container>

                    </ng-container>

                    <!-- Under development static page -->
                    <div *ngIf="docNotFound" class="doc-under-development">
                        <img src="assets/img/integration-guide-coming-soon.png" alt="Under development"
                            class="doc-under-development-img">
                        <h2 class="doc-under-development-title">Coming Soon</h2>
                        <p class="doc-under-development-text">
                            This page is currently being prepared and will be available shortly.
                        </p>
                    </div>
                </div>

                <!-- Prev / Next page navigation — separate card -->
                <div class="doc-nav-footer" *ngIf="prevMenuItem || nextMenuItem">
                    <button *ngIf="prevMenuItem" class="doc-nav-btn" (click)="navigateToPrev()">
                        <div class="doc-nav-prev">
                            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="10 4 6 8 10 12"></polyline>
                            </svg>
                            <span>{{ prevMenuItem.nodeName }}</span>
                        </div>
                    </button>
                    <button *ngIf="nextMenuItem" class="doc-nav-btn doc-nav-next" (click)="navigateToNext()">
                        <div class="doc-nav-next">
                            <span>{{ nextMenuItem.nodeName }}</span>
                            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6 4 10 8 6 12"></polyline>
                            </svg>
                        </div>
                    </button>
                </div>
            </div>

            <!-- Right-side TIMELINE navigation -->
            <aside class="doc-timeline" *ngIf="!docNotFound && (activeHeaderId === '' || timelineHeaders.length > 0)">
                <div class="doc-timeline-inner">
                    <p class="doc-timeline-label">TIMELINE</p>
                    <ul class="doc-timeline-list">
                        <!-- Page title as top-level entry -->
                        <!-- <li class="doc-timeline-item doc-timeline-title-item" [class.active]="activeHeaderId === ''">
                            <a class="doc-timeline-link doc-timeline-title-link" (click)="scrollToTop()">{{ pageTitle
                                }}</a>
                        </li> -->
                        <li *ngFor="let h of timelineHeaders" class="doc-timeline-item"
                            [class.active]="h.id === activeHeaderId">
                            <a class="doc-timeline-link" (click)="scrollToHeader(h.id)">{{ timelineLabel(h) }}</a>
                        </li>
                    </ul>
                </div>
            </aside>
        </div>
    </div>
</div>

<!-- Image lightbox -->
<div class="doc-lightbox-overlay" *ngIf="lightboxImage" (click)="closeLightbox()">
    <div class="doc-lightbox-content">
        <button type="button" class="doc-lightbox-close" (click)="closeLightbox()" aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>
        <img class="doc-lightbox-img" [src]="lightboxImage.src" [alt]="lightboxImage.alt"
            (click)="$event.stopPropagation()">
    </div>
</div>